import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { UpdateShopApi, DeleteShopApi } from "./Shop.action";
import MaterialSize from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewShop = (props) => {
  // const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  // const Checkpermissions = (permissionsType, permissionsName) => {
  //   return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
  // };

  useEffect(() => {
    props.setHeading("Shop List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialSize
          title="Shop List"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: 'Area Name', field: 'areaDetails.areaName', editable: 'never' },
            { title: 'Salesman Name', field: 'salesmenId.userName', editable: 'never' },
            { title: 'Shop Name', field: 'shopName' },
            { title: 'Shop Location', field: 'location' },
            {
              title: "Filer Status", field: "filerStatus", editable: 'never',
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor: rowData.filerStatus === true ? "#9FD983" : rowData.filerStatus === false ? "#F8B8A2" : "#f7cb74",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content"
                  }}
                >
                  {rowData.filerStatus === true ? "Active" : rowData.filerStatus === false ? "Inactive" : "N/A"}
                </div>
              ),
            },
            { title: 'Owner Name', field: 'ownerName' },
            { title: 'Owner Contact', field: 'ownerNumber' },
            { title: 'CNIC / NTN', field: 'ownerCnic' },
            { title: 'Description', field: 'shopDesc' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/shop/get-shops?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "l";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Shop Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.areaDetails.areaName,
                elt.salesmenId.userName,
                elt.shopName,
                elt.location,
                elt.filerStatus === true ? "Active" : elt.filerStatus === false ? "Inactive" : "N/A",
                elt.ownerName,
                elt.ownerNumber,
                elt.NTN,
                elt.ownerCnic,
                elt.shopDesc,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Shop Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Area Edit"),
            // isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Area Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.UpdateShopApi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteShopApi(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateShopApi: (newData, oldData) => dispatch(UpdateShopApi(newData, oldData)),
    DeleteShopApi: (shopId) => dispatch(DeleteShopApi(shopId)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewShop);